import { forwardRef } from 'react'
import './Input.css'

const Input = forwardRef(function Input({ label, error, className = '', id, as = 'input', rows = 3, ...rest }, ref) {
  const inputId = id ?? rest.name
  const Tag = as

  return (
    <div className={`ll-field ${error ? 'll-field--error' : ''} ${className}`.trim()}>
      {label && (
        <label htmlFor={inputId} className="ll-field__label">
          {label}
        </label>
      )}
      <Tag ref={ref} id={inputId} className="ll-field__input" rows={as === 'textarea' ? rows : undefined} {...rest} />
      {error && <span className="ll-field__error">{error}</span>}
    </div>
  )
})

export default Input
